module.exports = __webpack_public_path__ + "img/standard.b4a5661e.svg";